import { useAppUpdate } from '@reinz/app-update/useAppUpdate'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from '@/components/ui/sonner'

export function AppUpdatePrompt() {
  const { pathname } = useLocation()
  const isUpdateAvailable = useAppUpdate(pathname)

  useEffect(() => {
    if (!isUpdateAvailable) return
    toast('A new version of Companion is available.', {
      action: { label: 'Reload', onClick: () => window.location.reload() },
      duration: Number.POSITIVE_INFINITY,
    })
  }, [isUpdateAvailable])

  return null
}
